import { Button } from "primereact/button";
import { DataView } from "primereact/dataview";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppointmentStore } from "src/features/appointment/services/useAppointmentStore";
import { useAuthStore } from "src/features/auth/services/useAuthStore";
import { ParticipantModel } from "src/features/participant/models/participantModel";
import { useParticipantStore } from "src/features/participant/services/useParticipantStore";
import type { AppointmentStepProps } from "../../AppointmentPage";
import "./AppointmentStep1.css";

export function AppointmentStep1({ setActiveStepIndex }: AppointmentStepProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const authStore = useAuthStore();
  const participantStore = useParticipantStore();
  const appointmentStore = useAppointmentStore();

  useEffect(() => {
    if (appointmentStore.quickAppointment) {
      appointmentStore.setQuickAppointment(false);

      setActiveStepIndex(
        (appointmentStore.selectedDoctorProfile?.profileId ?? 0) !== 0
          ? 3
          : appointmentStore.selectedClinic
          ? 2
          : 1
      );
      return;
    }

    if (appointmentStore.withoutRegLogin) {
      appointmentStore.setWithoutRegLogin(false);
      setActiveStepIndex(4);
      return;
    }

    appointmentStore.clear();

    if (participantStore.participants?.length === 0) {
      appointmentStore.setSelectedPerson(personMySelf);
      setActiveStepIndex(1);
    }
  }, []);

  const personMySelf = new ParticipantModel({
    id: 0,
    name: t("Home.Appointments.ForMyself"),
    phone: authStore.user?.phone,
  });

  const persons = [personMySelf, ...participantStore.participants];

  const onPersonSelect = (person: ParticipantModel) => {
    appointmentStore.setSelectedPerson(person);

    setActiveStepIndex(1);
  };

  return (
    <div className="appointmentStep1 grid">
      <div className="col-12">
        <DataView
          value={persons}
          header={
            <div className="flex gap-3">
              <div>
                <Button
                  icon="pi pi-chevron-left"
                  label={t("Home.Start")}
                  onClick={() => {
                    navigate("/home");
                  }}
                ></Button>
              </div>
            </div>
          }
          listTemplate={(items?: ParticipantModel[]) => {
            if (!items || items.length === 0) return null;

            let list = items.map((item, index) => {
              return (
                <div
                  key={item.id}
                  className={
                    "col-12 sm:col-6 lg:col-4 xl:col-3 p-2 my-0 mx-auto " +
                    (index > 0 ? "border-top-1 surface-border" : "")
                  }
                >
                  <Button
                    text
                    raised
                    className="flex flex-column align-items-center gap-1 text-xl w100"
                    onClick={() => {
                      onPersonSelect(item);
                    }}
                  >
                    <i
                      className={
                        "pi " + (item.id == 0 ? "pi-user" : "pi-users")
                      }
                      style={{ fontSize: "2rem" }}
                    ></i>
                    <div className="flex flex-row gap-1">
                      <span className="font-bold">{item.name}</span>
                    </div>
                  </Button>
                </div>
              );
            });

            return <>{list}</>;
          }}
        />
      </div>
    </div>
  );
}
